module.exports = ".info-container .error {\n  margin: 0px auto;\n  display: block;\n  line-height: 20px;\n  width: 300px;\n  padding: 50px 0px 0px; }\n\n.info-container .exit {\n  margin: 20px 0; }\n\n.info-container .bottom {\n  position: fixed;\n  bottom: 0px;\n  background: #0074FF;\n  width: 100%;\n  height: 50px;\n  line-height: 50px;\n  color: #fff; }\n\n.info-container .bold {\n  font-size: 14px;\n  font-weight: 400;\n  color: grey; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/opt-in/optIn.component.scss
// module id = ./src/app/containers/opt-in/optIn.component.scss
// module chunks = main